import { render, staticRenderFns } from "./DirectCodeInput.html?vue&type=template&id=1a494f16&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./DirectCodeInput.scss?vue&type=style&index=0&id=1a494f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a494f16",
  null
  
)

export default component.exports